var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30469 4.94971C3.30469 4.03862 4.04253 3.30078 4.95362 3.30078H28.0539C28.965 3.30078 29.7029 4.03862 29.7029 4.94971V28.05C29.7029 28.9611 28.965 29.699 28.0539 29.699H4.95362C4.04253 29.699 3.30469 28.9611 3.30469 28.05V4.94971ZM6.60405 6.60019V26.3996H26.4034V6.60019H6.60405Z",
    fill: "#3E5EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90093 0V4.94984H6.60156V0H9.90093ZM18.1517 0V4.94984H14.8508V0H18.1517ZM26.4009 0V4.94984H23.1016V0H26.4009Z",
    fill: "#3E5EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90093 28.0508V33.0006H6.60156V28.0508H9.90093ZM18.1517 28.0508V33.0006H14.8508V28.0508H18.1517ZM26.4009 28.0508V33.0006H23.1016V28.0508H26.4009Z",
    fill: "#3E5EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.59961H4.94984V9.89898H0V6.59961ZM0 14.8488H4.94984V18.1497H0V14.8488ZM0 23.0996H4.94984V26.399H0V23.0996Z",
    fill: "#3E5EFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0469 6.59961H32.9967V9.89898H28.0469V6.59961ZM28.0469 14.8488H32.9967V18.1497H28.0469V14.8488ZM28.0469 23.0996H32.9967V26.399H28.0469V23.0996Z",
    fill: "#3E5EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7218 15.7624L15.0211 9.16211L17.9725 10.6378L15.8672 14.8499H19.7962C20.3685 14.8499 20.8991 15.1469 21.2007 15.6326C21.5008 16.1199 21.5286 16.7262 21.2719 17.2382L17.9725 23.8385L15.0212 22.3629L17.1264 18.1507H13.1974C12.6251 18.1507 12.0945 17.8538 11.7929 17.368C11.4928 16.8808 11.465 16.2744 11.7218 15.7624Z",
    fill: "#3E5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpu);
export default __webpack_public_path__ + "static/media/cpu.f8a40820c9f5ca1faa15841569bfe159.svg";
export { ForwardRef as ReactComponent };